import { RefObject } from 'react';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { ChipHeaders, FilterContext } from '@interfaces-clean/observations.interface';

type ShowDialog = { setTrue: () => void };

export function checkFiltersApplied(
    context: FilterContext,
    parentChipRef: RefObject<ChipHeaders>,
    childChipRef: RefObject<ChipHeaders>,
    parentFilter: RefObject<CompositeFilterDescriptor | null>,
    childFilter: RefObject<CompositeFilterDescriptor | null>,
    showFilterAppliedDialog: ShowDialog,
): void {
    switch (context) {
        case FilterContext.DeleteSubjectObservation:
            if (parentChipRef.current === ChipHeaders.ObservationsView) {
                if (parentFilter.current !== null || childFilter.current !== null) {
                    showFilterAppliedDialog.setTrue();
                }
            }
            break;

        case FilterContext.AddObservation:
            if (parentChipRef.current === ChipHeaders.ObservationsView) {
                if (parentFilter.current !== null || childFilter.current !== null) {
                    showFilterAppliedDialog.setTrue();
                }
            }
            break;

        case FilterContext.AddAction:
            if (childChipRef.current === ChipHeaders.ActionView && childFilter.current !== null)
                showFilterAppliedDialog.setTrue();
            break;

        case FilterContext.AddReviewLog:
            if (childChipRef.current === ChipHeaders.ReviewLogView && childFilter.current !== null)
                showFilterAppliedDialog.setTrue();
            break;

        case FilterContext.ParentBulkUpdate:
            if (parentFilter.current !== null) {
                showFilterAppliedDialog.setTrue();
            }
            break;
        case FilterContext.ChildBulkUpdate:
            if (childFilter.current !== null) {
                showFilterAppliedDialog.setTrue();
            }
            break;
        default:
    }
}
